<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-button
              outline
              color="success"
              @click="translateUnfilledFields"
            >一件翻译绿色Field</va-button>
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.courseId'
              v-show="showUid"
              label='唯一标识'
              disabled
            />
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.views'
              v-show="showViews"
              label='感兴趣人数'
              disabled
            />
          </div>

          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="课程名称"
              :placeholder="placeholders.name"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.nameEn"
              label="课程名称(英文)"
              :placeholder="placeholders.nameEn"
              removable
              :messages="message"
              :error="!!error.nameEnErrors.length"
              :error-messages="error.nameEnErrors"
              success
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-select
              label="课程标签"
              v-model="insertData.courseTagIds"
              multiple
              :options="computedTags"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-select
              label="导师"
              v-model="insertData.mentorUids"
              multiple
              searchable
              :options="computedMentors"
            />
          </div>
          <div class='flex md12 sm6 xs12' v-show="insertData.imgUrl.length!==0">
            <va-card
              overlay
              :image='insertData.imgUrl'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-card title='封面图'>
              <va-file-upload
                type='single'
                v-model='insertData.imgUrlArr'
                @input="uploadImage"
              />
            </va-card>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-button flat small>项目简介</va-button>
            <vue-trix
              v-model="insertData.projectDescription"
              :placeholder="placeholders.projectDescription"
              removable
              id="desc-job"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-button color=success  small>项目简介(英文)</va-button>
            <label for="desc-job-en"></label>
            <vue-trix
              v-model="insertData.projectDescriptionEn"
              :placeholder="placeholders.projectDescriptionEn"
              removable
              id="desc-job-en"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.intendedFor"
              :placeholder="placeholders.intendedFor"
              label="适用人群"
              :autosize="true"
              removable
              :messages="message"
              :error="!!error.intendedForErrors.length"
              :error-messages="error.intendedForErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.intendedForEn"
              :placeholder="placeholders.intendedForEn"
              label="适用人群(英文)"
              :autosize="true"
              removable
              :messages="message"
              :error="!!error.intendedForEnErrors.length"
              :error-messages="error.intendedForEnErrors"
              success
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-tree-category isOpen label="专题内容(左边中文, 右边英文)">
              <va-tree-node
                v-for="chapter in insertData.chapters"
                :key="chapter.id"
              >
                <div class="flex row align--center">
                  <va-input v-model="chapter.content" removable :placeholder="placeholders.chapters.content" class="mb-0 flex md5 sm6 xs12"/>
                  <va-input v-model="chapter.contentEn" removable :placeholder="placeholders.chapters.contentEn" class="mb-0 flex md5 sm6 xs12" success/>
                  <va-icon
                    name="ion ion-md-close"
                    color="info"
                    class="ml-2 pa-1 shrink" d
                    style="cursor: pointer;"
                    @click.native="removeChapter(chapter)"
                  />
                </div>
              </va-tree-node>
              <va-tree-node>
                <va-button class="mb-2" @click="addChapter()">
                  新增专题内容
                </va-button>
              </va-tree-node>
            </va-tree-category>
          </div>

          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.guarantee"
              :placeholder="placeholders.guarantee"
              label="求职保障(可选)"
              :autosize="true"
              removable
              :messages="['Optional field']"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.guaranteeEn"
              :placeholder="placeholders.guaranteeEn"
              label="求职保障(英文，可选)"
              :autosize="true"
              removable
              :messages="['Optional field']"
              success
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-select
              label="状态"
              v-model="insertData.status"
              :options="statusOptions"
              :messages="message"
              :error="!!error.statusErrors.length"
              :error-messages="error.statusErrors"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越大越靠前"
              removable
              type="number"
              :min="1"
              oninput="if(value<1)value=1"
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.createTime"
              label="创建时间"
              disabled
              v-show="showCreateTime"
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import uploadApi from '../../../api/upload'
import jobCounselingApi from '../../../api/jobCounseling'
import { copyObject, formatTime, translateData } from '../../../utils/common'
import mentorApi from '../../../api/mentor'
import { SERVICE_STATUS_TYPES, TAG_TYPE } from '../../../utils/constants'
import tagApi from '../../../api/tag'

export default {
  data () {
    return {
      insertData: {
        id: null,
        courseId: '',
        name: '',
        nameEn: '',
        imgUrl: '',
        imgUrlArr: [],
        views: null,
        projectDescription: '',
        projectDescriptionEn: '',
        intendedFor: '',
        intendedForEn: '',
        status: '草稿中',
        sortNum: 1,
        courseTagIds: [],
        mentorUids: [],
        chapters: [],
        createTime: null,
        guarantee: '',
        guaranteeEn: '',
        creatorUid: '',
      },
      placeholders: {
        name: '例: 北美计算机求职面试训练营',
        nameEn: 'Example: North American Computer Job Interview Training Camp',
        projectDescription: '例: 1. FLAG一线公司导师，精品小班课程，全方位1V1辅导，性价比高。\n' +
            '2. 面试培训讲解，定期Mock interview指导，线上线下组队学习，锁定OFFER。\n' +
            '3. 强大内推网络，提供各个大公司内推职位，帮助学员更快拿到面试。\n' +
            '4. 课程采用 理论讲解 + 在线quiz + 课后练习 的形式，强化学员对知识的理解',
        projectDescriptionEn: 'Example: 1. FLAG’s first-line company tutors, high-quality small class courses, all-round 1V1 tutoring, and high cost performance.\n' +
            '2. Interview training explanation, regular mock interview guidance, online and offline team learning, lock in OFFER.\n' +
            '3. A powerful internal referral network provides internal referral positions in various large companies to help students get interviews faster.\n' +
            '4. The course adopts the form of theoretical explanation + online quiz + after-class exercises to strengthen students’ understanding of knowledge.',
        intendedFor: '1. 适用于： 在校学生申请实习，刚毕业学生寻找全职，非CS转专业学员。\n' +
            '2. 学习成绩中等，想找一份工作留美，在大班培训下无法脱颖而出的学员。\n' +
            '3. 没有足够预算申请昂贵补习班，但又想夯实算法数据结构的学员',
        intendedForEn: '1. Applicable to: current students applying for internships, recent graduates looking for full-time students, non-CS major transfer students. \n' +
             '2. Students with average academic performance who want to find a job to study in the United States but cannot stand out in large class training. \n' +
             '3. Students who do not have enough budget to apply for expensive cram schools, but want to solidify algorithm data structures',
        guarantee: '例: 项目结题时，学员将有更多面试机会并且轻松自如应对面试，表现优异者有机会得到硅谷名企名企导师的推荐信以及相关职位的内推机会',
        guaranteeEn: 'Example: At the end of the project, students will have more interview opportunities and can handle interviews with ease. Those with outstanding performance will have the opportunity to receive letters of recommendation from mentors at famous Silicon Valley companies and internal referral opportunities for related positions.',
        chapters: {
          content: '例: 数据结构',
          contentEn: 'Example: data structure',
        },
      },
      message: ['Required field'],
      courseTags: [],
      mentors: [],
      error: {
        nameErrors: [],
        nameEnErrors: [],
        sortNumErrors: [],
        intendedForErrors: [],
        intendedForEnErrors: [],
        statusErrors: [],
      },
      showId: false,
      showUid: false,
      showViews: false,
      showCreateTime: false,
      title: '新增求职辅导',
      statusOptions: ['草稿中', '已发布', '已下架'],
      submitButtonStatus: true,
    }
  },
  created () {
    const params = this.$route.params
    if (params.id != null) {
      this.showId = true
      this.showUid = true
      this.showViews = true
      this.showCreateTime = true
      this.title = '编辑求职辅导'
      // 通过id获取详情
      jobCounselingApi.getJobCounseling(params.id).then(response => {
        copyObject(response.jobCounseling, this.insertData)
        this.insertData.createTime = formatTime(this.insertData.createTime)
        // eslint-disable-next-line no-prototype-builtins
        if (response.jobCounseling.hasOwnProperty('status')) {
          if (response.jobCounseling.status === 0) {
            this.insertData.status = '草稿中'
          } else if (response.jobCounseling.status === 1) {
            this.insertData.status = '已发布'
          } else {
            this.insertData.status = '已下架'
          }
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.hasOwnProperty('courseTags') && response.courseTags.length !== 0) {
          const that = this
          that.insertData.courseTagIds = []
          response.courseTags.forEach(x => {
            that.insertData.courseTagIds.push(x.name)
          })
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.hasOwnProperty('mentors') && response.mentors.length !== 0) {
          const that = this
          that.insertData.mentorUids = []
          response.mentors.forEach(x => {
            that.insertData.mentorUids.push(x.nickname + '(' + x.uid + ')')
          })
        }
        // eslint-disable-next-line no-prototype-builtins
        if (response.jobCounseling.hasOwnProperty('chapters') && response.jobCounseling.chapters.length !== 0) {
          const that = this
          this.insertData.chapters = []
          response.jobCounseling.chapters.forEach(x => {
            that.insertData.chapters.push({
              id: Math.floor(Math.random() * 100000),
              content: x.content,
              contentEn: x.contentEn,
            })
          })
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
    this.listCourseTag()
    this.listMentor()
  },
  computed: {
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.nameEnErrors.length &&
          !this.error.sortNumErrors.length &&
          !this.error.statusErrors.length &&
          !this.error.intendedForEnErrors.length &&
          !this.error.intendedForErrors.length
    },
    computedTags () {
      return this.courseTags.map(x => {
        return x.name
      })
    },
    flipTags () {
      const flipTags = {}
      this.courseTags.forEach(x => {
        flipTags[x.name] = x.id
      })
      return flipTags
    },
    computedMentors () {
      return this.mentors.map(x => {
        return x.nickname + '(' + x.uid + ')'
      })
    },
    flipMentors () {
      const flipMentors = {}
      this.mentors.forEach(x => {
        flipMentors[x.nickname + '(' + x.uid + ')'] = x.uid
      })
      return flipMentors
    },
  },
  methods: {
    listMentor () {
      const params = {
        pageNumber: 1,
        pageSize: 1000,
      }
      mentorApi.listMentor(params).then(response => {
        this.mentors = response.mentors
      }).catch(error => {
        this.showToast('获取导师列表失败', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        console.log(error)
      })
    },
    listCourseTag () {
      tagApi.listTag({ tagType: TAG_TYPE.COURSE_TAG.CODE }).then(response => {
        this.courseTags = response.tags
      }).catch(error => {
        this.showToast('获取标签列表失败', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        console.log(error)
      })
    },
    addChapter () {
      this.insertData.chapters.push({
        id: Math.floor(Math.random() * 100000),
        content: '',
        contentEn: '',
      })
    },
    removeChapter (chapter) {
      this.insertData.chapters = this.insertData.chapters.filter(x => x !== chapter)
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      if (!this.insertData.projectDescription) {
        this.showToast('请填写项目简介', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      if (this.insertData.imgUrl.length === 0) {
        this.showToast('有图片未上传，请请检查后重试！', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }

      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        nameEn: this.insertData.nameEn,
        courseId: this.insertData.courseId,
        views: this.insertData.views,
        imgUrl: this.insertData.imgUrl,
        releaseTime: this.insertData.releaseTime,
        intendedFor: this.insertData.intendedFor,
        intendedForEn: this.insertData.intendedForEn,
        projectDescription: this.insertData.projectDescription,
        projectDescriptionEn: this.insertData.projectDescriptionEn,
        guarantee: this.insertData.guarantee,
        guaranteeEn: this.insertData.guaranteeEn,
        sortNum: this.insertData.sortNum !== null ? this.insertData.sortNum : 1,
        creatorUid: this.insertData.creatorUid,
        chapters: this.insertData.chapters.map(x => {
          return {
            content: x.content,
            contentEn: x.contentEn,
          }
        }),
        courseTagIds: this.insertData.courseTagIds.map(tagName => {
          return this.flipTags[tagName]
        }),
        mentorUids: this.insertData.mentorUids.map(nicknameWithUid => {
          return this.flipMentors[nicknameWithUid]
        }),
      }
      if (this.insertData.status !== null) {
        SERVICE_STATUS_TYPES.map((item) => {
          if (this.insertData.status === item.TEXT) {
            data.status = item.CODE
          }
        })
      }

      if (this.insertData.id != null) {
        data.id = this.insertData.id
        jobCounselingApi.updateJobCounseling(data.id, data).then(response => {
          if (response.success === true) {
            this.showToast('更新求职辅导成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listJobCounseling' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      } else {
        jobCounselingApi.saveJobCounseling(data).then(response => {
          if (response.success === true) {
            this.showToast('添加求职辅导成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listJobCounseling' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.nameEnErrors = this.insertData.nameEn ? [] : ['nameEn is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
      this.error.statusErrors = this.insertData.status ? [] : ['status is required']
      this.error.intendedForErrors = this.insertData.intendedFor ? [] : ['intendedFor is required']
      this.error.intendedForEnErrors = this.insertData.intendedForEn ? [] : ['intendedForEn is required']
    },
    uploadImage () {
      if (this.insertData.imgUrlArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'image')
      formData.append('file', this.insertData.imgUrlArr[this.insertData.imgUrlArr.length - 1])
      uploadApi.uploadImage(formData).then(response => {
        this.insertData.imgUrl = response.url
        this.showToast('上传图片成功', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    async translateUnfilledFields () {
    // 课程标题
      if (this.insertData.name !== '' && this.insertData.nameEn === '') {
        this.insertData.nameEn = await translateData(this.insertData.name)
      }
      // 适用人群
      if (this.insertData.intendedFor !== '' && this.insertData.intendedForEn === '') {
        this.insertData.intendedForEn = await translateData(this.insertData.intendedFor)
      }
      // 课程介绍
      if (this.insertData.projectDescription !== '' && this.insertData.projectDescriptionEn === '') {
        this.insertData.projectDescriptionEn = await translateData(this.insertData.projectDescription)
      }
      // 课程大纲
      if (this.insertData.guarantee !== '' && this.insertData.guaranteeEn === '') {
        this.insertData.guaranteeEn = await translateData(this.insertData.guarantee)
      }
      // 专题
      this.translateChapters(this.insertData.chapters)
    },
    async  translateChapters (chapters) {
      const translationPromises = chapters.map(async (x, index) => {
        if (x.content && !x.contentEn) {
          try {
            chapters[index].contentEn = await translateData(x.content)
          } catch (error) {
            console.error(`翻译专题 ${index} 时出现错误:`, error)
          }
        }
      })
      await Promise.all(translationPromises)
    },
  },

}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
